import { languageMap } from ".."

languageMap.art = languageMap.arturo = {
	comments: {
		line: ";",
	},
}
